package com.hyperether.goodjob.scenes.auth

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import org.hyperether.auth.microsoft.MicrosoftButtonContainer
import org.hyperether.auth.microsoft.MicrosoftButtonMode
import org.hyperether.auth.microsoft.MicrosoftSignInResult

@Composable
actual fun MicrosoftLogin(
    modifier: Modifier,
    mode: MicrosoftButtonMode,
    text: String,
    onResult: (Result<MicrosoftSignInResult?>) -> Unit
) {
    MicrosoftButtonContainer(
        modifier = modifier,
        text = text,
        mode = mode,
        onResult = onResult
    )
}